import Axios from 'axios';
import {
  PRODUCT_ADMIN_LIST_FAIL,
  PRODUCT_ADMIN_LIST_REQUEST,
  PRODUCT_ADMIN_LIST_SUCCESS,
  PRODUCT_CREATE_FAIL,
  PRODUCT_CREATE_REQUEST,
  PRODUCT_CREATE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_REORDER_FAIL,
  PRODUCT_REORDER_REQUEST,
  PRODUCT_REORDER_SUCCESS,
  PRODUCT_UPDATE_FAIL,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS,
} from '../constants/productConstants';
import { translateBackendMessage } from '../utils/translateError';

export const listAdminProducts =
  ({ page = 1, limit = 20, search = '', all = false } = {}) =>
  async (dispatch) => {
    dispatch({ type: PRODUCT_ADMIN_LIST_REQUEST });
    try {
      const params = new URLSearchParams({ page, limit });
      if (search) params.set('search', search);
      if (all) params.set('all', 'true');
      const { data } = await Axios.get(`/api/products?${params}`);
      dispatch({ type: PRODUCT_ADMIN_LIST_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: PRODUCT_ADMIN_LIST_FAIL, payload: error.message });
    }
  };

export const listProducts = () => async (dispatch) => {
  dispatch({ type: PRODUCT_LIST_REQUEST });
  try {
    const { data } = await Axios.get('/api/products');
    const products = Array.isArray(data) ? data : (data.items ?? []);
    dispatch({ type: PRODUCT_LIST_SUCCESS, payload: products });
  } catch (error) {
    dispatch({ type: PRODUCT_LIST_FAIL, payload: error.message });
  }
};

export const detailsProduct = (productId) => async (dispatch) => {
  dispatch({ type: PRODUCT_DETAILS_REQUEST });
  try {
    const { data } = await Axios.get(`/api/products/${productId}`);
    dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
      statusCode: error.response?.status,
    });
  }
};

export const createProduct = (product) => async (dispatch) => {
  dispatch({ type: PRODUCT_CREATE_REQUEST });
  try {
    const { data } = await Axios.post('/api/products', product);
    dispatch({ type: PRODUCT_CREATE_SUCCESS, payload: data.product });
  } catch (error) {
    dispatch({
      type: PRODUCT_CREATE_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};

export const updateProduct = (product) => async (dispatch) => {
  dispatch({ type: PRODUCT_UPDATE_REQUEST, payload: product });
  try {
    const { data } = await Axios.put(`/api/products/${product.slug}`, product);
    dispatch({ type: PRODUCT_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_UPDATE_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};

export const deleteProduct = (productId) => async (dispatch) => {
  dispatch({ type: PRODUCT_DELETE_REQUEST, payload: productId });
  try {
    await Axios.delete(`/api/products/${productId}`);
    dispatch({ type: PRODUCT_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: PRODUCT_DELETE_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};

export const reorderProducts = (items) => async (dispatch) => {
  dispatch({ type: PRODUCT_REORDER_REQUEST });
  try {
    await Axios.patch('/api/products/reorder', items);
    dispatch({ type: PRODUCT_REORDER_SUCCESS });
  } catch (error) {
    dispatch({
      type: PRODUCT_REORDER_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};
